<script>
import { defineComponent } from 'vue';
import TrackerConfig from '../../components/standaloneSnowplow/config/TrackerConfig';
import TitleDispatcher from "~/windowEvents/TitleDispatcher";
import BreadcrumbsBuilder from "~/helpers/BreadcrumbsBuilder";
import BreadcrumbsDispatcher from "~/windowEvents/BreadcrumbsDispatcher";
import { useRoute } from 'vue-router';

export default defineComponent({
  setup() {
    const route = useRoute();
    return { route };
  },
  beforeCreate: function() {
    window.nd = undefined;
    window.ndanalytics = null;
    document.querySelectorAll('script[async]').forEach(el => el.remove());
  },
  data: () => {
    return {
      tagger: null,
      taggerName: '',
      taggerConfig: {},
      currentTabAsObject: false,
      currentTab: null,
      events: [],
      contexts: []
    }
  },
  methods: {
    reloadTagger: function () {
      this.tagger = TrackerConfig.createTagger(this.taggerName, this.taggerConfig);
    },
    changeTab: function (data) {
      this.currentTab = data.tabName;
      this.currentTabAsObject = data.asObject;
    },
  },
  mounted() {
    this.tagger = TrackerConfig.createTagger(this.taggerName, this.taggerConfig);
    const title = 'Snowplow tester';
    const breadcrumbs = new BreadcrumbsBuilder().addItem(this.route, title);
    BreadcrumbsDispatcher.dispatchItems(breadcrumbs);
    TitleDispatcher.dispatch(title);
  }
});
</script>
